import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * State and Actions
 */

type State = {
  resumoDescricao: string;
  centroCustos: number[] | null;
  status: number;
  dataAberturaInicio: Date | null;
  dataAberturaTermino: Date | null;
  dataEncerramentoInicio: Date | null;
  dataEncerramentoTermino: Date | null;
};

/**
 * initialChecklistServicoObrasItemState
 */

export const initialChecklistServicoObrasItem: State = {
  resumoDescricao: '',
  centroCustos: null,
  status: 1,
  dataAberturaInicio: null,
  dataAberturaTermino: null,
  dataEncerramentoInicio: null,
  dataEncerramentoTermino: null,
}

/**
 * useChecklistServicoObrasItemFilters
 */

export const useChecklistServicoObrasItemFilters = create<State>((set) => ({
  ...initialChecklistServicoObrasItem,
}));